<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="test.id">{{$t('modals.edit_test.title')}}</h1>
            <h1 v-else>{{$t('modals.create_test.title')}}</h1>
        </div>

        <test-form
            :test="test"
            :wrapperClass="['modal__content']"
            @saved="onTestUpdated">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </test-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import TestForm from '@/components/forms/dashboard/TestForm';

    import { GET_TESTS } from '@/store/modules/tests';

    @Component({
        components: {
            TestForm,
        }
    })
    export default class TestModal extends Vue {
        name = 'test-modal';

        test = {};

        beforeOpen(event) {
            if (event.params && event.params.test) {
                this.test = event.params.test;
            }
        }

        onTestUpdated(trajectory) {
            this.$notify.success(this.$t('notify.test.save_success'));
            this.refetchAndClose();
        }

        refetchAndClose() {
            this.$store.dispatch(GET_TESTS, {});
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/TestModal.vue